import React from 'react';
import InputControl from '../InputControl/InputControl';
import IconBin from '../Icons/IconBin/IconBin';
import { MetaField } from '../../store/models/cycles';

interface FieldInputProps {
  field: MetaField;
  onChange: (data: { key: string; value: string }) => void;
  onRemove?: () => void;
  keyError?: string | null,
  valueError?: string | null;
}

export const FieldInputV2: React.FC<FieldInputProps> = ({ field, onChange, onRemove, keyError, valueError }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;

    if (name === 'key') {
      onChange({ key: value, value: field.value })
    }

    if (name === 'value') {
      onChange({ value, key: field.key })
    }
  };

  return (
    <div className="flex w-full items-center gap-4 field-input">
      <div className="flex-1">
        <InputControl
          label="Key"
          placeholder="Enter key"
          defaultValue={field.key}
          name="key"
          onChange={handleChange}
          errorText={keyError || ''}
          showError={Boolean(keyError)}
        />
      </div>
      <div className="flex-1">
        <InputControl
          label="Value"
          placeholder="Enter value"
          defaultValue={field.value}
          name="value"
          onChange={handleChange}
          errorText={valueError || ''}
          showError={Boolean(valueError)}
        />
      </div>
      {onRemove && (
        <button onClick={onRemove} className="ml-2 mt-6 text-meta-1 hover:text-meta-1/80">
          <IconBin />
        </button>
      )}
    </div>
  );
};
